import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useSelector } from "react-redux";
import { useScrollPosition } from "../../hooks/useScrollPosition";
import { Jumbotron } from "./migration";
import SkillsTab from "./SkillsTab";

const Skills = React.forwardRef(({ heading, hardSkills, softSkills }, ref) => {
	const skillsTabRef = React.useRef(null);
	const [isScrolled, setIsScrolled] = React.useState(false);
	//const navbarDimensions = useResizeObserver(navbarMenuRef);

	useScrollPosition(
		({ prevPos, currPos }) => {
			if (!isScrolled && currPos.y - 400 < 0) setIsScrolled(true);
		},
		[],
		skillsTabRef
	);

	const setLanguage = useSelector((state) => state.estado.value);
	if (setLanguage === false) {
		heading = "Habilidades";
	}

	return (
		<Jumbotron
			ref={skillsTabRef}
			fluid
			className="bg-white m-0"
			id="skills"
		>
			<Container className="p-5 ">
				<h2 ref={skillsTabRef} className="display-4 pb-5 text-center">
					{heading}
				</h2>
				<Tabs
					className="skills-tabs"
					defaultActiveKey="hard-skills"
					id="skills-tabs"
					fill
				>
					<Tab
						tabClassName="skills-tab lead"
						eventKey="hard-skills"
						title="Technical Skills"
					>
						<Row className="pt-3 px-1">
							<SkillsTab
								skills={hardSkills}
								isScrolled={isScrolled}
							/>
						</Row>
					</Tab>
					<Tab
						tabClassName="skills-tab lead"
						eventKey="soft-skills"
						title="Certifications"
					>
						<Row className="pt-3 px-1">
							<SkillsTab
								skills={softSkills}
								isScrolled={isScrolled}
							/>
						</Row>
					</Tab>
				</Tabs>
			</Container>
		</Jumbotron>
	);
});

export default Skills;
